import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** QR sticker links land here; redirect to main tracking page (same design). */
export default function PackageTracking() {
  const [searchParams] = useSearchParams();
  const p = searchParams.get('p');
  const target = p ? `/tracking?p=${encodeURIComponent(p)}` : '/tracking';
  return <Navigate to={target} replace />;
}
